<script>
import Refund from "../mixins/refund";
import SetOption from "../mixins/setOption";
export default {
  mixins: [Refund, SetOption],
  data() {
    return {
      // 交易编号
      trade_no: "",
      schedulheadInfo: {
        branchId: "",
        deptId: "",
        deptName: "",
        docId: "",
        docName: "",
        hospitalId: "",
        noonCode: "",
        noonName: "",
        regFee: "4.40",
        regLevelId: "",
        regLevelName: "",
        schedulId: "",
        schedulTypeId: "",
        seeDate: "",
        validFlag: "",
        visitBeginTime: "",
        visitEndTime: "",
      },
    };
  },
  methods: {
    //获取排班表信息
    async queryschedulhead(deptId, docId, regDate) {
      try {
        this.$showLoad();
        let ret = await this.$axios.post("/register/queryschedulhead", {
          deptId: deptId,
          docId: docId,
          dateBeg: regDate,
          dateEnd: regDate,
        });
        this.schedulheadInfo = { ...ret.data[0].doctorList[0] };
      } catch (error) {
        console.log(error);
        this.$hideLoad();
        this.$toast.fail("获取预约挂号信息失败, 请重试");
      }
    },
    // 获取交易编号
    async getPreTradeNo(medCardNo, preId) {
      try {
        // 获取 交易编号
        let no_Data = await this.$axios.get(
          `/register/getPreTrade_no?medCardNo=${medCardNo}&preId=${preId}`
        );
        if (no_Data.status === 200) this.trade_no = no_Data.data;
        this.$hideLoad();
        // 提示是否立即支付
        if (this.trade_no !== "") {
          this.getPayData(
            this.trade_no,
            preId,
            medCardNo,
            this.schedulheadInfo.regFee
          );
        }
      } catch (error) {
        console.log(error);
        this.$hideLoad();
        this.$toast.fail("获取交易编号失败，请重试");
      }
    },
    // 下单及获取支付相关信息
    async getPayData(trade_no, preId, medCardNo, totalcost) {
      try {
        let requestData = {
          out_trade_no: this.trade_no,
          total_fee: parseInt((totalcost - 0) * 100),
          body: "峨山县人民医院微信公众号挂号费用",
          detail: "峨山县人民医院微信公众号挂号费用",
          openId: this.$local.get("openId"),
        };
        let ret = await this.$axios({
          method: "post",
          url: "/pay/getH5PayData",
          data: requestData,
        });
        if (ret.data.RspStatus) {
          this.pay(ret.data.RspContent, preId, medCardNo, totalcost);
        } else {
          this.$hideLoad();
          this.$toast.fail("获取支付信息失败，请前往费用支付菜单中支付");
        }
      } catch (error) {
        console.log(error);
        this.$hideLoad();
        this.$toast.fail("获取支付信息失败，请前往费用支付菜单中支付");
      }
    },
    // 支付函数
    pay(respContent, preId, medCardNo, totalcost) {
      try {
        if (typeof WeixinJSBridge == "undefined")
          return this.$toast.fail("请在微信内部使用");
        WeixinJSBridge.invoke(
          "getBrandWCPayRequest",
          respContent,
          async (res) => {
            // console.log(res.err_msg);
            if (res.err_msg == "get_brand_wcpay_request:ok") {
              this.registerCommit(preId, medCardNo, totalcost);
            } else {
              // console.log(this.$route.name);
              if (this.$route.name === "scheduldetail")
                this.$toast.fail("支付失败或取消，请前往费用支付菜单支付");
              if (this.$route.name === "paymentOfFees")
                this.$toast.fail("支付失败或取消，请重试");
            }
          }
        );
      } catch (error) {
        console.log(error);
        this.$hideLoad();
        if (this.$route.name === "scheduldetail")
          this.$toast.fail("支付失败或取消，请前往费用支付菜单支付");
        if (this.$route.name === "paymentOfFees")
          this.$toast.fail("支付失败或取消，请重试");
      }
    },
    // 支付成功后 患者挂号信息确认   ---------  确认失败如何处理
    async registerCommit(preId, medCardNo, totalcost) {
      this.$hideLoad(); // 关闭其他的弹窗
      try {
        this.$showLoad("支付确认中...");
        let requestData = {
          preId: preId,
          channel: "09",
          needRegFee: true,
          tradeNo: this.trade_no,
        };
        let ret = await this.$axios({
          method: "post",
          url: "/register/registercommit",
          data: requestData,
        });
        this.$hideLoad();
        if (ret.status === 200) {
          this.$toast.success("预约挂号成功！可在使用记录中查看");
          this.$router.push("/useRcorder");
          setTimeout((_) => {
            if (this.$route.name === "paymentOfFees") this.$bus.$emit("reload");
          }, 2000);
        } else if (ret.errors) {
          await setTimeout(() => {
            this.$toast.fail("支付失败,已自动帮您申请退款");
          }, 1000);
          console.log(ret.errors);
          this.getRefundId(medCardNo, this.trade_no, totalcost, "", "");
        }
      } catch (error) {
        console.log(error);
        this.$hideLoad();
        //  失败处理。。。。。
        this.$toast.fail("支付失败,已自动帮您申请退款");
        this.getRefundId(medCardNo, this.trade_no, totalcost, "", "");
      }
    },
  },
};
</script>